import { render, staticRenderFns } from "./CheaterStatusLevel.vue?vue&type=template&id=5a37132e&scoped=true&"
import script from "./CheaterStatusLevel.vue?vue&type=script&lang=js&"
export * from "./CheaterStatusLevel.vue?vue&type=script&lang=js&"
import style0 from "./CheaterStatusLevel.vue?vue&type=style&index=0&id=5a37132e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a37132e",
  null
  
)

export default component.exports